export function setActiveNewBottomMenuItem(ref: string): boolean {
  const item = document.querySelector(`[data-ref=${ref}] .c-header-link-title`);

  if (item && !item.classList.contains('c-header-link-title-active')) {
    const oldActiveItem = document.querySelector('[data-ref=bottom_menu] .c-header-link-title-active');
    if (oldActiveItem) {
      oldActiveItem.classList.remove('c-header-link-title-active');
    }
    item.classList.add('c-header-link-title-active');

    return true;
  }

  return false;
}
